import styled from "styled-components";

export const HeaderFlex = styled.span`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-direction: column;
  .mobile-hidden {
    display: none;
  }
  @media (min-width: 1023px) {
    flex-direction: row;
    .desktop-hidden {
      display: none;
    }
    .mobile-hidden {
      display: inline;
    }
  }
`;

export const HeroTop = styled(HeaderFlex)`
  margin-bottom: 12px;

  .decor {
    display: none;
    position: absolute;
    top: 50%;
    width: 300px;
    height: 16px;
    object-fit: contain;
    object-position: center;
    &--left {
      left: -16px;
      transform: translate(-100%, -30%);
    }
    &--right {
      right: -16px;
      transform: translate(100%, -30%);
    }
  }
  @media (min-width: 1023px) {
    .decor {
      display: block;
    }
  }
`;

export const HeroBadge = styled.span`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  border-radius: var(--rounding-radius-xxxl, 48px);
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  backdrop-filter: blur(12px);
  padding: var(--spacing-space-4, 4px) var(--spacing-space-4, 4px)
    var(--spacing-space-4, 4px) var(--spacing-space-24, 24px);
  white-space: nowrap;
  margin-bottom: 6px;
  @media (min-width: 1023px) {
    margin-bottom: 0;
  }
`;

export const HeroTimes = styled.span`
  border-radius: var(--rounding-radius-xxxl, 48px);
  background: var(--fill-elevated, rgba(204, 187, 184, 0.16));
  box-shadow: 0px 8px 24px 0px rgba(51, 20, 0, 0.08),
    0px 4px 8px 0px rgba(51, 20, 0, 0.04);
  padding: 20px var(--spacing-space-16, 16px) 22px var(--spacing-space-20, 20px);
  display: flex;
  align-items: center;
  justify-content: center;
  span.headerM {
    line-height: 1;
  }
`;

export const HeroCamelot = styled(HeroBadge)`
  background: #ffaf1d;
  color: var(--text-primary-on-light, #000);
  gap: 10px;
  padding: 20px var(--spacing-space-24, 24px) 20px;
  margin-bottom: 0;
  margin-top: 6px;
  font-size: 40px;
  img {
    width: 38px;
    height: 38px;
    object-fit: contain;
  }

  @media (min-width: 1023px) {
    margin-top: 0;
    padding: 16px var(--spacing-space-24, 24px) 16px;
  }
`;
